<!-- el-dialog二次封装 -->
<template>
  <el-dialog
    class="shippingBox"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    title="Choose Shipping Method"
    width="680px">
    <el-select v-model="countryName" filterable size="small" class="shippingSelect" placeholder="Please Choose" @change="changeCuntry()">
      <el-option v-for="(item,index) in region" :key="index" :label="item.nameEn" :value="item.nameEn + ':' + item.name + ';'"></el-option>
    </el-select>
    <!-- 运费列表 -->
    <div class="shippingList">
      <div class="shippingListHead">
        <span>Shipping Method</span>
        <span>Shipping Time</span>
        <span>Shipping Cost</span>
      </div>
      <div class="min-Height">
      <div class="shippingListItem"
        v-show="showList === 1"
        v-for="(item, index) in jjShipping"
        :key="index">
        <el-radio class="shippingRadio" v-model="radio" :label="item.id" @change="changeRegion(item)"></el-radio>
        <span class="shippingMethod">{{item.name}}</span>
        <span class="shippingTime">{{getCurDays(item)}}</span>
        <span class="shippingCost">{{item.freightAmount ? `${currency} ${item.freightAmount}` : '-' }}</span>
      </div>
      </div>
    </div>
    <!-- 不在配送范围内 -->
    <div class="unShoppingArea min-Height" v-show="showList === 2">
      <i class="iconfont iconprompt_filling"/>This Supplier/Shipping Company does not deliver to your selected Country/Region.
    </div>
    <!-- 部分地区免运费 -->
    <div class="unShoppingArea min-Height" v-show="showList === 3">
      <i class="iconfont iconLogistics"/>Free shipping
    </div>
    <!-- 按钮 apply -->
    <div class="shippingFooter">
      <el-button type="primary" size="small" @click="apply">Apply</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import orderAPI from '@/api/index/orderApi.js'
import indexApi from '@/api/index/indexApi.js'

export default {
  name: 'olDialog',
  props: {
    width: {
      type: String,
      default: '30%'
    },
    title: {
      type: String,
      default: '提示'
    },
    visible: {
      type: Boolean,
      default: false
    },
    center: Boolean,
    selectItem: Object,
    curItem: Object,
    productId: String,
    shopInfo: Object,
    disableCountry: String
  },
  data () {
    return {
      countryName: '',
      region: [],
      radio: '',
      showList: '',
      select: {},
      jjShipping: []
    }
  },
  computed: {
     ...mapGetters(['currency'])
  },
  watch: {
    visible(val) {
      if (val) {
        console.log(this.curItem, this.productId, this.selectItem);
        // indexApi.getPriceInfo({
        //   productId: this.selectItem.product.id,
        //   productSpecId: this.curItem.productSpec.id,
        //   quantity: this.curItem.quantity,
        //   countryNameEn: this.curItem.receiveCountry
        // }).then(res => {
        //   this.countryName = this.curItem.receiveCountryFormat
        //   if (!res.data.code) {
        //     this.selectItem.logisticsInfo.logisticsFreightVOS.map(v => {
        //       res.data.data.forEach(v1 => {
        //         if (v1.freightTemplateId === v.id) {
        //           v.freightAmount = v1.freightAmount
        //         }
        //       })
        //       return v
        //     })
        //   }
        //   this.changeCuntry(true)
        // })
        this.countryName = this.curItem.receiveCountryFormat
        this.changeCuntry(true)
      }
    },
  },
  mounted() {
    this.countryList()
  },
  methods: {
    getCurDays (item) {
      if (!item.logistFreightDetails) return ''
      const arr = item.logistFreightDetails.filter(v => v.receiveCountrys.includes(this.countryName))
      if (arr.length && arr[0].arrInMaxDays && arr[0].arrInMinDays) {
        return `${arr[0].arrInMinDays} - ${arr[0].arrInMaxDays} days`
      } else {
        return '-'
      }
    },
    countryList () {
      if (localStorage.getItem('region') != null){
        this.region = JSON.parse(localStorage.getItem('region'))
        this.$emit('getAddressInfo',this.region)
      } else {
        orderAPI.countryList().then(res=>{
          if (!res.data.code) {
            let region = res.data.data
            localStorage.setItem('region',JSON.stringify(region))
            this.region = region
          }
        })
      }
    },
    changeCuntry (flag) {
      console.log(this.selectItem)
      indexApi.getPriceInfo({
        productId: this.selectItem.productId,
        productSpecId: this.curItem.productSpec.id,
        quantity: this.curItem.quantity,
        countryNameEn: (this.countryName || '').split(':')[0]
      }).then(res => {
        if (!res.data.code) {
          this.selectItem.logisticsInfo.logisticsFreightVOS.map(v => {
            res.data.data.forEach(v1 => {
              if (v1.freightTemplateId === v.id) {
                v.freightAmount = v1.freightAmount
              }
            })
            return v
          })
        }
        this.radio = ''
        if (flag) {
          this.radio = this.curItem.freightTemplateId
          this.select.name = this.curItem.freightTemplateName
          this.select.freightTemplateId = this.curItem.freightTemplateId
          this.select.receiveCountry = (this.countryName || '').split(':')[0]
          this.select.receiveCountryFormat = this.countryName
        }
        this.jjShipping = this.selectItem.logisticsInfo.logisticsFreightVOS.filter(v => v.country.includes(this.countryName))
        if (this.jjShipping.length > 0) {
          this.showList = 1
        } else {
          this.showList = 2
        }
        console.log('this.jjShipping', this.jjShipping, this.countryName)
      })
    },
    cancelDialog () {
      this.$emit('update:visible', false)
    },
    changeRegion (item) {
      console.log('changeRegion', item, item.radio);
      if (this.radio) {
        this.select.name = item.name
        this.select.freightTemplateId = item.id
        this.select.receiveCountry = (this.countryName || '').split(':')[0]
        this.select.receiveCountryFormat = this.countryName
      }
    },
    closeDialog () {
      this.$emit('update:visible', false)
    },
    beforeClose () {
      this.$emit('update:visible', false)
    },
    apply() {
      if (this.showList === 1) {
        this.curItem.freightTemplateId = this.select.freightTemplateId
        this.curItem.receiveCountry = this.select.receiveCountry
        this.curItem.freightTemplateName = this.select.name
        this.curItem.showType = 2
        this.curItem.receiveCountryFormat = this.select.receiveCountryFormat
        this.$emit('updateShipingList', this.shopInfo, this.selectItem, this.curItem)
        this.$emit('update:visible', false)
      } else {
        this.$message.error('Please select a shipping method');
      }
    }
  }
}
</script>
<style lang="less">
.lx-dialog.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-dialog__body {
    padding: 20px;
    min-height: 240px;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
.shippingBox{
  .el-dialog__header{
    .el-dialog__title{
      font-size: 16px;
    }
  }
  .el-dialog__body{
    padding: 20px;
    .shippingSelect{
      margin-bottom: 20px
    }
    .shippingList{
      .shippingListHead{
        background: #F5F6F7;
        height: 40px;
        line-height: 40px;
        display: flex;
        color: #8E9DAC;
        font-size: 14px;
        span:nth-child(1){
          padding-left: 34px;
          flex: 0 0 281px;
        }
        span:nth-child(2){
          flex: 0 0 193px;
        }
        span:nth-child(3){
          flex: 0 0 132px;
        }
      }
      .shippingListItem{
        display: flex;
        height: 48px;
        line-height: 48px;
        box-shadow: 0px 1px 0px 0px #E6EAEE;
        .shippingRadio{
          flex: 0 0 34px;
          margin: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-radio__label{
            display:none;
          }
        }
        .shippingMethod{
          flex: 0 0 281px;
        }
        .shippingTime{
          flex: 0 0 193px;
        }
        .shippingCost{
          flex: 0 0 132px;
        }
      }
    }
    .unShoppingArea{
      background-color: #fdf6eb;
      padding: 10px;
      font-size: 14px;
      line-height: 20px;
      i{
        font-size: 20px;
        color: #FEA000;
        margin-right: 10px;
      }
    }
    .shippingFooter{
      margin-top: 40px;
      display: flex;
      justify-content: center;
      .button{
        height: 32px;
        line-height: 32px;
        font-size: 14px;
      }
    }
  }
  .min-Height {
    // min-height: 160px;
  }
}
</style>
